<template>
  <div>
    <b-tabs pills align="left">
      <b-tab title="DTM Pay" active>
        <b-card-text>
          <dtmpay />
          <!-- {{ tabData[0]["home"] }} -->
        </b-card-text>
      </b-tab>
      <b-tab title="REG Pay">
        <b-card-text>
          <regpay />
          <!-- {{ tabData[1]["profile"] }} -->
        </b-card-text>
      </b-tab>
      <b-tab title="Donate Pay">
        <donatepay />
        <!-- {{ tabData[2]["disabled"] }} -->
      </b-tab>
      <b-tab title="Payment Status">
        <b-card-text>
          <paymentstatus />
          <!-- {{ tabData[3]["about"] }} -->
        </b-card-text>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab, BCardText } from "bootstrap-vue";
import paymentstatus from "@/components/cashPay/payment-status.vue";
import dtmpay from "@/components/cashPay/dtm-pay.vue";
import regpay from "@/components/cashPay/reg-pay.vue";
import donatepay from "@/components/cashPay/donate-pay.vue";

export default {
  name: "cashPay",
  components: {
    BTabs,
    BTab,
    BCardText,
    paymentstatus,
    dtmpay,
    regpay,
    donatepay,
  },
  data() {
    return {
      tabData: [
        {
          home: "Candy canes donut chupa chups candy canes lemon drops oat cake wafer. Cotton candy candy canes marzipan carrot cake. Sesame snaps lemon drops candy marzipan donut brownie tootsie roll. Icing croissant bonbon biscuit gummi bears. Pastry gummi bears sweet roll candy canes topping ice cream. Candy canes fruitcake cookie carrot cake pastry.",
        },
        {
          profile:
            "Carrot cake dragée chocolate. Lemon drops ice cream wafer gummies dragée. Chocolate bar liquorice cheesecake cookie chupa chups marshmallow oat cake biscuit. Dessert toffee fruitcake ice cream powder tootsie roll cake.Pudding candy canes sugar plum cookie chocolate cake powder croissant.",
        },
        { disabled: "lorem" },
        {
          about:
            "Carrot cake dragée chocolate. Lemon drops ice cream wafer gummies dragée. Chocolate bar liquorice cheesecake cookie chupa chups marshmallow oat cake biscuit. Dessert toffee fruitcake ice cream powder tootsie roll cake.Carrot cake dragée chocolate. Lemon drops ice cream wafer gummies dragée. Chocolate bar liquorice cheesecake cookie chupa chups marshmallow oat cake biscuit.",
        },
      ],
    };
  },
};
</script>